import Typography from '@material-ui/core/Typography';
import DescriptionIcon from '@material-ui/icons/Description';
import PropTypes from 'prop-types';
import React from 'react';

class VisiblePropertyDisplay extends React.Component {

    render() {

        const { data, defaultLang, info } = this.props;

        const title = data.hasOwnProperty("label") ?
            data.label[defaultLang] ?
                data.label[defaultLang]
                :
                data.label["und"] ?
                    data.label["und"]
                    :
                    data.id
            :
            data.id;

        return (
            <span>
                <Typography variant="body2" style={{ fontWeight: 500 }}>{info.name || title}</Typography>
                {info.description &&
                    <span style={{ marginBottom: 12, display: 'inline-block' }}>
                        <Typography variant="body2"><DescriptionIcon style={{ transform: 'translateY(4px)' }} fontSize="small" /> <span data-test="description">{info.description}</span></Typography>
                    </span>
                }
            </span>
        );
    }
}

VisiblePropertyDisplay.defaultProps = {
};

VisiblePropertyDisplay.propTypes = {
    id: PropTypes.string.isRequired,
    info: PropTypes.object,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired
};

export default VisiblePropertyDisplay;